module.exports = __webpack_public_path__ + "static/media/mcgregor.04b5d564.jpg";